import { render, staticRenderFns } from "./Vod.vue?vue&type=template&id=effb9156&"
import script from "./Vod.vue?vue&type=script&lang=js&"
export * from "./Vod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports